import React, { useContext, useState } from 'react';
import { SetupDataPageTemplate } from '../../../components/setup-pages/SetupDataPageTemplate';
import { saveAsbestosHistory } from '../../../services/userService';
import { setupData } from '../../../configs/routes';
import { Form } from "react-jsonschema-form-validation";
import { pathRoot, getOptionsElements } from '../AsbestosHistory';
import { DiseaseGroupContext } from '../../../contexts/diseaseGroupContext';

export function Page4({ asbestosHistory, onSaveFailure }) {

	const schema = {
		type: "object"
	};

	const optionsData = [{
		label: "Yes",
		value: 0
	}, {
		label: "No",
		value: 1
	}, {
		label: "Don't know/Not applicable",
		value: 2
	}];

	const [helpIdentify, setHelpIdentify] = useState(asbestosHistory.helpIdentify ?? null);

	const backTo = () => {
		if (asbestosHistory.occupationHistory.some(e => e === 0)) {
			return (`${pathRoot}/3`);
		}

		return (`${pathRoot}/2`);
	};

	const updateUserSettings = () => {
		asbestosHistory.helpIdentify = helpIdentify;
	};

	const hideNext = () => {
		return helpIdentify === null;
	};

	const onFinish = () => {
		return new Promise((resolve, reject) => {
			updateUserSettings();
			asbestosHistory.complete = true;
			saveAsbestosHistory(asbestosHistory).then(resolve).catch((error) => onSaveFailure(error));
		});
	};

	const headerDetails = {
		title: "Asbestos History",
		currentPage: 4,
		pageCount: 4
	};

	const {theme} = useContext(DiseaseGroupContext);

	return (<><SetupDataPageTemplate headerDetails={headerDetails} backTo={backTo()} nextTo={setupData} onClickBack={updateUserSettings} onClickNext={{func: onFinish, async: true}} hideNext={hideNext()} nextTextOverride={"Finish"}>
		
			<Form schema={schema}>
				<p className={"text-lg sm:text-xl font-bold mb-6"}>If asbestos exposure is relevant to you, were you ever helped to identify where the asbestos exposure may have occurred?</p>
				<div>
					{getOptionsElements(optionsData, "helpIdentify", helpIdentify, setHelpIdentify, theme)}
				</div>
			</Form>
		
	</SetupDataPageTemplate></>);
}
